import { React, useEffect, useState } from "react";
import {
  RightDrawerContainer,
} from "../../styledElements";
import { JobCardColorStatus } from "../../pageStyled";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import {
  getProductionDetailsForOrder
} from "../../../Services/orderServices";
import moment from "moment";
import { Tooltip } from "antd";
import { getWorkflowSettings } from "../../../Services/workFlowSettingsServices";

const capitalize = (item) => item.charAt(0).toUpperCase() + item.slice(1);

const ProductionDetailsDrawer = (props) => {
  const [orderProductionDetails, setOrderProductionDetails] = useState();

  useEffect(() => {
   getWorkflowSettings("order_management").then((response1) => {
     props.selectedOrderNo &&
      getProductionDetailsForOrder(props.selectedOrderNo)
        .then((response) => {
          let productionDetails = response.data;
          if( response1?.data?.fetch_balance_quantity?.value)
          {
            productionDetails.forEach((item) => {
              item["displayState"] = capitalize(
                item?.erp_state === "active" || item?.state === "active"
                  ? "Active"
                  : item.state === "completed"
                  ? "Completed"
                  : item.state === "cancel"
                  ? "Cancelled" 
                  : item.state === "under_review"
                  ? "Under Review"
                  : item.state
              );
            });
          }
          else{
          productionDetails.forEach((item) => {
            item["displayState"] = capitalize(
              item.state === "in_process"
                ? "In Process"
                : item.state === "in_production"
                ? "In Production"
                : item.state === "cancel"
                ? "Cancelled"
                : item.state
            );
          });
        }
          setOrderProductionDetails(response.data);
        })
   })
    
    
        .catch((error) => {
          console.log(error);
        });
    return () => setOrderProductionDetails();
  }, [props?.selectedOrderNo]);

  const getJCCode = (str) => {
    if(str){
      let splittedString = str?.split("~");
      let mergeString;
      mergeString = splittedString?.join("");
      return mergeString;
    }
  };

  // const handleCancel = () => {
  //   props.handleCancel();
  // }

  return (
    <RightDrawerSidebar
      title={`Production Details - #${props.selectedOrderNo}`}
      subtitle=""
      visible={props.visible}
      onClose={() => {
        props.onCloseGrade();
      }}
    >
      <RightDrawerContainer>
        <div className="resetPassForm removePadLeft">
          {orderProductionDetails?.length ? (
          orderProductionDetails.map((item, index) => (
            <div>
              <div className="titleWithText" 
              // style={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}
              >
                {/* <div style={{paddingLeft: "22px"}}> */}
                <>
                  {(getJCCode(item?.jobcard_code))?.length > 26 ?
                    (<h5>Job Card: {" "}
                      <Tooltip title={getJCCode(item?.jobcard_code)}>
                      {(getJCCode(item?.jobcard_code)?.slice(0,27))+"..."}
                    </Tooltip>
                    </h5>) : (
                    <h5>Job Card: {" "} {getJCCode(item?.jobcard_code)}
                    </h5>)}
                </>
                {/* </div> */}
                {/* <JobCardColorStatus>
                <div className="statusVal" dataval={item.state} style = {{margin : "0 auto"}}>
                  {item.displayState}                   
                </div>
                </JobCardColorStatus> */}
              </div>
              <div className="titleWithText" style={{display: "flex", flexDirection: "row", justifyContent: "space-between", marginTop:"17px"}}>
                <p>Created On: {moment(item.created_date).format("DD MMM YYYY")}</p>
                {item.merged && (
                  <p>This jobcard has merged orders</p>
                )}
                <JobCardColorStatus>
                <div className="statusVal" dataval={item.state}>
                  {item.displayState}                   
                </div>
                </JobCardColorStatus>
              </div>
              <div style={{height: "1px", backgroundColor: "lightgray", marginTop: "10px", marginBottom: "10px"}}></div>
            </div>
          ))
          ) : orderProductionDetails?.length == 0 && (
            <div className="titleWithText" style={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
              <div style={{padding: "0 15px 0 15px", textAlign: "center", marginTop: "60%"}}>
                <h5>This order has not been matched in any job card yet</h5>
              </div>              
            </div>
          )}
          {/* <div className="buttonFlex fixedBtm" style={{ flexDirection: "row" }}>                  
            <div style={{ display: "flex", flexDirection: "row" }}>                    
              <Button
                style={{
                  padding: "0px 0px 0px 0px",
                  margin: "0px 10px 0px 0px",
                }}
                className="themeBtn noBg active"
                // disabled={details.state !== "pending"}
                onClick={() => handleCancel()}
              >
                <Iconmoon
                  icon="wrong"
                  size={16}
                  color="#EA655B"
                />{" "}
                Cancel{" "}
              </Button>                            
            </div>
          </div> */}
        </div>
      </RightDrawerContainer>
    </RightDrawerSidebar>
  )
};

export default ProductionDetailsDrawer;